import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// ------------------- Menu -----------------------
import BootstrapMenuBar from "components/menu/BootstrapMenuBar";
// ------------------- TS Expert -----------------------
import TSExpert from "components/ts-expert/TSExpert";
// ------------------- Protocol -----------------------
import ProtocolResume from "components/monitor/resume/Resume";
import ProtocolLiveList from "components/monitor/LiveList";
import ProtocolLiveListMatrix from "components/monitor/LiveListMatrix";
import ProtocolGraphicTopology from "components/monitor/GraphicTopology";
import EventLogOLM from "components/olm/EventLogOLM";
import OpticFiber from "components/olm/OpticFiber";
import ProtocolEventLog from "components/monitor/EventLog";
// ------------------- Analyzer DP -----------------------
import AnalyzerDPLiveList from "components/analyzer-dp/LiveList";
import AnalyzerDPLiveListMatrix from "components/analyzer-dp/LiveListMatrix";
import AnalyzerDPOscilloscope from "components/analyzer-dp/Oscilloscope";
import AnalyzerDPOscilloscope2 from "components/analyzer-dp/Oscilloscope2";
import AnalyzerDPBarGraph from "components/analyzer-dp/BarGraph";
import AnalyzerDPEventLog from "components/analyzer-dp/EventLog";
// ------------------ Configs -----------------------
import Configuration from "components/login-config/configuration/Configuration";
// ------------------ Login -----------------------
import Login from "components/login-config/login/Login";
import LoginHandler from "components/login-config/login/LoginHandler";
// ------------------ Constants / Strings / Utils -----------------------
import Constants from "utilities/Constants";
import Utils from "./utilities/Utils";
import OpticFiberConfig from "./components/login-config/configuration/general/OpticFiberConfig";

const UtilsInstance = new Utils();

class App extends Component {

  retrieveData = async () => {

    let isFiberProcessOn = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "fiber/isFiberProcessOn", { mode: "cors" })
      .then(UtilsInstance.checkStatus)
      .then(res => res.json())
      .then(data => data.isFiberProcessOn)
      .catch((e) => {
        console.log("Request problem: ", e);
        return false;
      });

    let requireReload = false;

    if (sessionStorage.getItem("isFiberProcessOn") === null || String(isFiberProcessOn) !== sessionStorage.getItem("isFiberProcessOn")) {
      requireReload = true;
    }

    sessionStorage.setItem("isFiberProcessOn", isFiberProcessOn);

    if (requireReload) {
      window.location.reload();
    }
  }

  componentDidMount = async () => {
    this.retrieveData();
    if (localStorage.getItem(Constants.LOCAL_STORAGE_KEY) === null) {
      let language = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "language", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.language);

      localStorage.setItem(Constants.LOCAL_STORAGE_KEY, language);
      window.location.reload();
    }
  };

  render() {
    return (
      <Router basename={process.env.PUBLIC_URL}>
        <div className="App">
          <BootstrapMenuBar />
          <div style={mainAppContentStyle}>
            <Switch>
              {/* ------------------ TS Expert------------------ */}
              <Route exact path="/" component={TSExpert} />
              {/* ------------------ Protocol Routes------------------ */}
              <Route path="/protocol-resume" component={ProtocolResume} />
              <Route exact path="/protocol-livelist" component={ProtocolLiveList} />
              <Route exact path="/protocol-livelist/:address" component={ProtocolLiveList} />
              <Route path="/protocol-livelist-matrix" component={ProtocolLiveListMatrix} />
              <Route path="/protocol-graphic-topology" component={ProtocolGraphicTopology} />
              <Route path="/protocol-log" component={ProtocolEventLog} />
              {/* ------------------ Optic Fiber------------------ */}
              <Route path="/optic-fiber" component={OpticFiber} />
              <Route path="/optic-fiber-log" component={EventLogOLM} />
              {/* ------------------ Physical Medium DP Routes------------------ */}
              <Route exact path="/dp-live-list" component={AnalyzerDPLiveList} />
              <Route path="/dp-live-list-matrix" component={AnalyzerDPLiveListMatrix} />
              <Route path="/dp-oscilloscope" component={AnalyzerDPOscilloscope} />
              <Route path="/dp-oscilloscope2" component={AnalyzerDPOscilloscope2} />
              <Route path="/dp-bar-graph" component={AnalyzerDPBarGraph} />
              <Route path="/dp-log" component={AnalyzerDPEventLog} />
              {/* ------------------ Config ------------------ */}
              <Route path="/config" component={Configuration} />
              <Route path="/optic-fiber-config" component={OpticFiberConfig} />
              {/* ------------------ Login ------------------ */}
              <Route path="/login" component={Login} />
              <Route path="/login-handler" component={LoginHandler} />
            </Switch>

          </div>
        </div>
      </Router>
    );
  }
}

// CSS Custom App Margins
const mainAppContentStyle = {
  marginLeft: "24px",
  marginRight: "24px",
};

export default App;
